<template>
  <section>
    <template v-if="tempContract.id != undefined">
      <ContractModalHeader
        :contract="contract"
        :tempContract="tempContract"
        :allContractData="allContractData"
        :cancellationMode="cancellationMode"
        :salesAdditiveType="salesAdditiveType"
        :disableCancelSale="disableCancelSale"
        :productHasFee="productHasFee"
        :productsToCancel="productsToCancel"
        :totalFees="totalFees"
        @changeSalesAdditiveType="changeSalesAdditiveType"
        @onChangeProductsToCancel="onChangeProductsToCancel"
        @onContractCancelModeFinish="updateContractsList"
      />

      <ContractModalTabs
        ref="contractModalTabs"
        :contract="contract"
        :tempContract="tempContract"
        :allContractData="allContractData"
        :cancellationMode="cancellationMode"
        :contractedServices="contractedServices"
        :emailIsSent="emailIsSent"
        :salesAdditiveType="salesAdditiveType"
        :disableCancelSale="disableCancelSale"
        :productsToCancel="productsToCancel"
        :totalFees="totalFees"
        @onChangeCancelProductData="onChangeCancelProductData"
        @onClickChangeCancellationMode="onClickChangeCancellationMode"
        @updateContractsList="updateContractsList"
        @onFinishActions="updateContractsList"
      />
    </template>

    <template v-if="tempContract.id == undefined">
      <div class="text-center mt-20 pd-20">
        <a-skeleton active class="mb-10" />
        <a-skeleton active class="mb-10" />
        <a-skeleton active />
      </div>
    </template>
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings";
import contractMixins from "../mixins/contractMixins";
import cancelModeMixins from "../mixins/cancelModeMixins";
import ContractModalTabs from "../tabs/ContractModalTabs.vue";
import ContractModalHeader from "../sections/ContractModalHeader.vue";

export default {
  name: "ContractModal",
  components: {
    ContractModalTabs,
    ContractModalHeader,
  },
  props: { contractId: String },
  mixins: [contractMixins, cancelModeMixins, formatThings],
  data() {
    return {
      contract: {},
      tempContract: {},
      contractedServices: [],
      contractDataFromDatabase: {},
      emailIsSent: false,
      productsToCancel: [],
    };
  },
  beforeMount() {
    this.getContract();
  },
  methods: {
    updateTotalFees() {
      this.totalFees = this.tempContract[
        "contract_cancellation_mode_total_fees_value"
      ]
        ? parseFloat(
            this.tempContract["contract_cancellation_mode_total_fees_value"]
          )
        : 0;
    },
    onChangeProductsToCancel(productsToCancel) {
      if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
        this.tempContract[`products_to_cancel`] =
          JSON.stringify(productsToCancel);

        setTimeout(() => {
          this.verifySelectedProductsToCancel(productsToCancel);
        }, 100);
      }
    },
    verifySelectedProductsToCancel(productsToCancel) {
      if (
        this.cancellationMode &&
        ["Alterar", "Cancelar"].includes(this.salesAdditiveType)
      ) {
        if (productsToCancel.length) {
          const contractedServices = this.tempContract.contracted_services
            ? JSON.parse(this.tempContract.contracted_services)
            : [];

          setTimeout(() => {
            this.contractedServices = contractedServices.filter((service) =>
              productsToCancel.some((product) => product.startsWith(service))
            );

            this.productsToCancel = productsToCancel;

            this.$refs.contractModalTabs.$emit("emitProductsToCancel");
          }, 100);
        } else {
          this.contractedServices = [];
          this.productsToCancel = [];
          this.$refs.contractModalTabs.$emit("emitProductsToCancel");
        }
      }
    },
    onChangeCancelProductData(tempContract) {
      this.tempContract = tempContract;
      this.verifySaleCancelation();
    },
    updateContractsList() {
      this.$emit("updateContractsList");
    },
    changeSalesAdditiveType(type) {
      this.tempContract.sales_additive_type = type;
      this.$refs.contractModalTabs.$emit("emitProductsToCancel");
      this.salesAdditiveType = type;

      if (type === "Cancelar Venda") {
        this.contractedServices = this.tempContract.contracted_services
          ? JSON.parse(this.tempContract.contracted_services)
          : [];
      } else {
        setTimeout(() => {
          this.contractedServices = [];
          this.setProductsToCancel();
          this.verifySaleCancelation();
        }, 100);
      }
    },
    onClickChangeCancellationMode(status) {
      this.cancellationMode = status;
      this.$refs.contractModalTabs.$emit("emitProductsToCancel");
      console.log(status);
      if (!status) {
        this.contractedServices = this.tempContract.contracted_services
          ? JSON.parse(this.tempContract.contracted_services)
          : [];
      } else {
        setTimeout(() => {
          if (["Alterar", "Cancelar"].includes(this.salesAdditiveType))
            this.contractedServices = [];
          this.updateTotalFees();
          this.setProductsToCancel();
          this.verifySaleCancelation();
        }, 100);
      }
    },
    setProductsToCancel() {
      this.productsToCancel =
        this.tempContract.products_to_cancel != undefined
          ? JSON.parse(this.tempContract.products_to_cancel)
          : [];

      if (this.productsToCancel.length) {
        this.verifySelectedProductsToCancel(this.productsToCancel);
      }
    },
    getContract() {
      this.$http
        .post(`/contract-v2/details?id=${this.contractId}`)
        .then(({ data }) => {
          this.contract = data;
          this.tempContract = {
            ...data,
            the_customer: data.customer,
          };

          let allFieldsSize = Object.values(data.meta).length,
            values = Object.values(data.meta),
            keys = Object.keys(data.meta);

          for (let i = 0; i < allFieldsSize; i++) {
            this.tempContract[keys[i]] = values[i];
          }

          this.tempContract.user = this.tempContract.user.id;
          this.tempContract.customer_id = this.tempContract.customer.id;

          delete this.tempContract.meta;
          delete this.tempContract.customer;

          this.contractDataFromDatabase = this.tempContract;

          this.contractedServices = data.contracted_services
            ? JSON.parse(data.contracted_services)
            : [];

          this.salesAdditiveType =
            this.tempContract.sales_additive_type != undefined
              ? this.tempContract.sales_additive_type
              : "Cancelar Venda";

          if (this.tempContract.contract_email_is_sent != undefined) {
            this.emailIsSent =
              this.tempContract.contract_email_is_sent == 1 ? true : false;
          }

          if (this.tempContract.sale_id == 0) this.autoUpdateSaleIdOnContract();

          this.contractPricingData(this.tempContract);
        });
    },
    autoUpdateSaleIdOnContract() {
      this.$http
        .post(
          `/sale/list?page=1&per_page=1&contract-id=${this.tempContract.id}&order=desc&order-by=created`
        )
        .then(({ data }) => {
          this.tempContract.sale_id = data.data[0].id;

          this.$http.post("/contract-v2/update-field", {
            id: this.tempContract.id,
            field: "sale_id",
            value: data.data[0].id,
          });
        });
    },
  },
};
</script>
